import { render, staticRenderFns } from "./mProgramContent.vue?vue&type=template&id=511d8c83&scoped=true&"
import script from "./mProgramContent.vue?vue&type=script&lang=js&"
export * from "./mProgramContent.vue?vue&type=script&lang=js&"
import style0 from "./mProgramContent.vue?vue&type=style&index=0&id=511d8c83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d8c83",
  null
  
)

export default component.exports